module.exports = __webpack_public_path__ + "static/img/16bg_1.73d6e4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_1.png
// module id = 657
// module chunks = 1